module.exports = __webpack_public_path__ + "static/media/zeder.8e261d7e.png";